<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Conversion
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="product"
                outlined
                v-model="form.product_id"
                :items="productItems"
                label="Product"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.product_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="raw Material"
                outlined
                v-model="form.raw_material_id"
                :items="rawmaterialItems"
                label="Raw Material"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.raw_material_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Edit Conversion
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "MaterialConversionEditPage",
  data() {
    return {
      form: {
        product_id: "",
        raw_material_id: "",
        quantity: "0",
        is_active: false,
      },
      rawmaterialItems: [],
      productItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`material_conversions/masters`)
        .then((masters) => {
          masters = masters.data;
          //products masters
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.id,
            });
          });
          //Raw Material masters
          masters.rawmaterials.forEach((rawmaterial) => {
            this.rawmaterialItems.push({
              id: rawmaterial.id,
              text: rawmaterial.name,
              value: rawmaterial.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.materialConversionId;
      axios
        .get(`/material_conversions/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(
          `/material_conversions/${this.$route.params.materialConversionId}`,
          this.form
        );
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/material_conversion/${this.form.id}`,
          from_name: "ConversionEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/material-conversions");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
